import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/pages/homework-play/homework-play.tsx",
    () => import("./homework-play"),
    <PageLoader isFullPage/>,
);
